import { Element, Class } from "@webhare-system/frameworks/mootools/core";
import ScrollMonitor from 'dompack/extra/scrollmonitor';
var $todd = require("./support");
var KeyboardBunny = require("@webhare-system/dom/keyboard");


// ---------------------------------------------------------------------------
//
// Codeedit
//

$todd.ObjCodeEdit = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "codeedit"


  // ---------------------------------------------------------------------------
  //
  // Variables
  //

, linenumberholder: null
, linenumberdiv: null
, linenumberpre: null
, textarea: null
, enabled: null
, isactive: false
, markerholderdiv: null
, markerscrolldiv: null

, donelinenumbers: 0
, pendinggotoline: 0
, pendinggotoline_attop: false
, synctimer: null

, markers: []

  // ---------------------------------------------------------------------------
  //
  // Constructor
  //

, initialize: function(parentcomp, data, response, replacingcomp)
  {
    this.parent(parentcomp, data, response, replacingcomp);

    this.buildNode();
    this.textarea.value = data.value;
    this.markers = data.markers;

    this.syncLineNumbers();
    this.syncScroll();

    this.syncMarkers();

    this.setEnabled(data.enabled);
    this.executeActions(data.actions);

    this.syncMarkers.bind(this).delay(1);
  }

  // ---------------------------------------------------------------------------
  //
  // Helper stuff
  //

, buildNode: function()
  {
    this.node = new Element('t-codeedit',
                           { "data-name": this.name
                           , "styles": { "position": "relative" }
                           });

    this.linenumberswidth = 36;

    this.linenumberbg = new Element('div', { 'class': 'gutter-background' }).inject(this.node);

    this.markerholderdiv = new Element('div',
                                      { 'class': 'marker-container'
                                      , styles: {
/*                                                , position: "absolute"
                                                , top: "0"
                                                , left: "0"
                                                , width: "100%"
                                                , height: "100%"
                                                , background: "transparent"
                                                , "z-index": -1*/
                                                }
                                      }).inject(this.node);

    this.markerscrolldiv = new Element('div',
                                      { 'class': 'marker-scroller'
                                      , styles: {
/*                                                , background: "transparent"
                                                , overflow: "visible"*/
                                                }
                                      }).inject(this.markerholderdiv);

    this.linenumberdiv = new Element('div', { 'class': 'gutter-content'
/*                                            , style: { position: 'relative'
                                                     , top: '0px'
                                                     }*/
                                            }).inject(this.node);

    this.linenumberdiv.setAttribute('unselectable', "on");

    // No Flash available, create an HTML textarea
    this.textarea = new Element('textarea', { wrap: "off"
                                            , spellcheck: false
                                            , styles: { "margin-left": this.linenumberswidth + 2
//                                                      , background: "transparent"
                                                      }
                                            , events: { "scroll": this.gotScrollEvent.bind(this)
                                                      }
                                            }).inject(this.node);

    new KeyboardBunny(this.textarea, {}, { dontpropagate: ['Enter']});
    this.linenumberdiv.addEvent('click', this.gotGutterClick.bind(this));
  }

, syncLineNumbers: function()
  {
    // ADDME: calculating number of lines basedon scrollheight/lineheight might be faster?
    var needed_linenumbers = this.textarea.value.split('\n').length + 200;

    //console.log("need: "+needed_linenumbers+" have: "+this.donelinenumbers);

    if (this.donelinenumbers >= needed_linenumbers)
      return;

    //console.log("creating extra numbers, need: "+needed_linenumbers+" have: "+this.donelinenumbers);

    var extranumbers='';
    while(this.donelinenumbers < needed_linenumbers)
      extranumbers += ++this.donelinenumbers + '\n';

    this.linenumberdiv.appendText(extranumbers);
    this.markerscrolldiv.style.height = this.linenumberdiv.scrollHeight + 'px';
  }

, syncMarkers: function()
  {
    var linenumberdivheight = this.linenumberdiv.scrollHeight;
    var lineheight = linenumberdivheight / this.donelinenumbers;

    this.markerscrolldiv.empty();
    this.markerscrolldiv.style.height = this.linenumberdiv.scrollHeight + 'px';
    this.markerholderdiv.scrollTop = this.linenumberdiv.scrollTop;

    this.markers.forEach(function(item)
    {
      var is_gutter_marker = item.type.substr(0,6) == "gutter";

      new Element('div', { "class":   "marker " + item.type
                         , "styles":  { "margin-left":   is_gutter_marker ? 0 : this.linenumberswidth + 'px'
                                      , "width":         is_gutter_marker ? this.linenumberswidth + 'px' : "100%"
                                      , "top":           lineheight * (item.line - 1) + "px"
                                      , "height":        lineheight + "px"
                                      , "background":    item.color
                                      }
                         }).inject(this.markerscrolldiv);
    }.bind(this));
  }

, setSelection: function(startpos, limitpos)
  {
    this.textarea.selectionStart = startpos;
    this.textarea.selectionEnd = limitpos;
  }

, gotoLine: function(line, attop)
  {
    if(!this.isactive)
    {
      this.pendinggotoline=line;
      this.pendinggotoline_attop=attop;
      return;
    }

    this.syncLineNumbers();
    var selectpos = line == 0 ? 0 : this.textarea.value.split('\n').slice(0,line).join('\n').length + 1;
    try
    {
      this.setSelection(selectpos, selectpos);
    }
    catch(ex)
    {
      console.error("Caught exception while setting selection. Exception: " + ex.name + " Message: " + ex.message);
    }

    var lineheight = this.linenumberdiv.scrollHeight / this.donelinenumbers;

    if (attop)
    {
      // Topline: honor exactly
      this.textarea.scrollTop = Math.max(0, line) * lineheight;
    }
    else
    {
      // When scrolling to first 3 or last 3 lines in view, scroll as little as possible
      // to get 3 lines of context
      // else center the view on the line
      var minfull_scroll = Math.max(0, (line + 1) * lineheight - this.textarea.offsetHeight);
      var maxfull_scroll = Math.max(0, line * lineheight);

      var min_scroll = Math.max(0, (line + 4) * lineheight - this.textarea.offsetHeight);
      var max_scroll = Math.max(0, (line - 3) * lineheight);

      // No 3 lines of context? Meh, always center
      if (max_scroll < min_scroll)
        max_scroll = min_scroll = line * lineheight - (this.textarea.offsetHeight - lineheight) / 2;

      if (this.textarea.scrollTop < minfull_scroll || this.textarea.scrollTop > maxfull_scroll)
        this.textarea.scrollTop = (min_scroll + max_scroll) / 2;
      else if (this.textarea.scrollTop < min_scroll)
        this.textarea.scrollTop = min_scroll;
      else if (this.textarea.scrollTop > max_scroll)
        this.textarea.scrollTop = max_scroll;
    }
    ScrollMonitor.saveScrollPosition(this.textarea);
  }

, gotScrollEvent: function()
  {
    this.syncScroll(false);
  }

, syncScroll: function(immediate)
  {
    var scrollTop = this.textarea.getScroll().y;
    //console.log("Scrollpos in scroll event: "+scrollTop);

    this.linenumberdiv.scrollTop = scrollTop;
    this.markerholderdiv.scrollTop = scrollTop;

    if (immediate)
      this.syncLineNumbers();
    else if (!this.synctimer)
      this.synctimer = this.delayedSyncLineNumbers.bind(this).delay(250);
  }

, delayedSyncLineNumbers: function()
  {
    this.synctimer = null;
    this.syncLineNumbers();
  }

, setEnabled: function(enabled)
  {
    if (this.enabled == enabled)
      return;

    this.textarea.readOnly = !enabled;
    this.enabled = enabled;
  }

, gotGutterClick: function(event)
  {
    // Get click y relative to target node
    var y = event.client.y;
    var element = event.target;
    var nextoffsetparent = element;
    while (nextoffsetparent)
    {
      if (element == nextoffsetparent)
      {
        y += element.scrollTop - element.offsetTop;
        nextoffsetparent = element.offsetParent;
      }
      else
        y += element.scrollTop;
      element = element.parentNode;
    }

    var lineheight = this.linenumberdiv.scrollHeight / this.donelinenumbers;
    this.queueMessage('gutterclick', { line: Math.floor(y / lineheight) + 1 }, true);
    event.preventDefault();
  }

  // ---------------------------------------------------------------------------
  //
  // Helper functions
  //

, executeActions: function(actions)
  {
    for (var i = 0; i < actions.length; ++i)
    {
      switch(actions[i].action)
      {
        case 'gotoline':
        {
          let line = actions[i].linenum - 1;
          if (this.node)
            this.gotoLine(line);
          else
            this.preselectline = line;
        } break;
        case 'gototopline':
        {
          let line = actions[i].linenum - 1;
          this.gotoLine(line, true);
        } break;
      }
    }
  }

  // ---------------------------------------------------------------------------
  //
  // Layouting
  //

, calculateDimWidth: function()
  {
    this.width.min = 200;
  }

, calculateDimHeight: function()
  {
    this.height.min = 200;
  }

, relayout: function()
  {
    this.node.setStyles({"width": this.width.set
                        ,"height": this.height.set
                        });

    this.textarea.setStyles(
        { width: (this.width.set - this.linenumberswidth - 2) + 'px'
        , height: this.height.set + 'px'
        });

    if(!this.isactive) //we'll save up the first gotoline until we get into view
    {
      this.isactive=true;
      this.gotoLine(this.pendinggotoline, this.pendinggotoline_attop);
    }

    this.linenumberbg.setStyles(
        { width: this.linenumberswidth + 'px'
        , height: this.height.set + 'px'
        });

    this.linenumberdiv.setStyles(
        { width: this.linenumberswidth + 'px'
        , height: this.height.set + 'px'
        });

    this.syncScroll(true);
  }

  // ---------------------------------------------------------------------------
  //
  // Callbacks & updates
  //

, applyUpdate: function(data, response)
  {
    switch(data.type)
    {
      case 'value':
        this.textarea.value = data.value;
        this.syncScroll(true);
        return;
      case 'enabled':
        this.setEnabled(data.value);
        return;
      case 'actions':
        this.executeActions(data.value);
        return;
      case 'markers':
        this.markers = data.value;
        this.syncMarkers();
        return;
    }

    this.parent(data, response);
  }

, getSubmitValue: function()
  {
    var lineheight = this.linenumberdiv.scrollHeight / this.donelinenumbers;

    var beforeselectionlines = this.textarea.value.substr(0, this.textarea.selectionStart).split('\n');

    return { enabled: this.enabled
           , line: beforeselectionlines.length
           , col: beforeselectionlines[beforeselectionlines.length - 1].length + 1
           , selection: this.textarea.value.substr(this.textarea.selectionStart, this.textarea.selectionEnd - this.textarea.selectionStart)
           , topline: lineheight ? Math.floor(this.textarea.scrollTop / lineheight + 1) : 1
           , value: this.enabled ? this.textarea.value : ""
           };
  }
});

// ---------------------------------------------------------------------------
//
// Registration
//

exports.components = { codeedit: $todd.ObjCodeEdit };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/codeedit.es